<template>
  <div class="breadcrumb pt-4 pb-4 mb-4">
    <template v-for="(item, index) of breadcrumbs">
      <router-link
      v-if="!item.disabled"
      :key="'a' + index"
      class="rlink-hover text--text"
      style="text-decoration: none;"
      :to="{ path: item.to}">
        <span>{{ item.name }}</span>
      </router-link>
      <span v-else class="textDisabled--text" :key="'b' + index">{{ item.name }}</span>
      <span v-if="index < breadcrumbs.length - 1" :key="'c' + index">&nbsp;/&nbsp;</span>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    breadcrumbs: null // [{to: 'www.gogle.com', name: name, disabled: true}]
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  font-size: 0.8rem;
  font-weight: 400;
  letter-spacing: 0.1666666667em;
  line-height: 1rem;
}

</style>